import { useEffect } from "react";
import { Outlet} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Flex } from "@chakra-ui/react";

import Header from "../../shared/Header/Header";
import "./UserLayout.scss";
import ClientSidebar from "../../components/ClientSidebar/ClientLeftSidebar";
import LeftSideNav from "../../shared/LeftSideNav/LeftSideNav";


const UserLayout = () => {
  // const dispatch = useDispatch();
  const { isAuthenticatedUser } = useSelector((state) => state.userReducer);

  // useEffect(() => {
  //   if (!userLoading) {
  //     dispatch(getClientDetails(clientId));
  //   }
  // }, [userLoading]);

  return (
    <>
      <Box w="100%" bg="var(--body-bg)">
        <Box>
          <Header />
        </Box>

        <Flex style={{ backgroundColor: "var(--sylvr-bg-color)" }}>
          {isAuthenticatedUser ? <ClientSidebar /> : <LeftSideNav />}
          <Box
            w="100%"
            h="calc(100% - var(--headerbar-height) - var(--footerbar-height))"
          >
            <Outlet />
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default UserLayout;
